import { css } from 'styled-components';

export const bezeledBadgeStyle = css`
  clip-path: polygon(0 0, 100% 0, 100% 100%, 29% 100%, 0 71%);
`;
